import React, { Component } from 'react'
import './Title.css'

class Title extends Component {
    render() {
        return (
            <div className="Title">
                <div className="maintitle size24 bold-font">
                    {this.props.maintitle}
                </div>
                <div className="secondarytitle size11">
                    {this.props.secondarytitle}
                </div>
                <div className="secondarytitle size13 bold-font">
                    {this.props.secondarytitlebold}
                </div>
                <div className="middleblack size18 bold-font">
                    {this.props.middleblack}
                </div>
            </div>
        )
    }
}

export default Title
